<template>
  <div>
    <el-dialog title="请使用微信扫码支付" width="300px" :visible.sync="value" :before-close="payClose">
      <div>
        <canvas id="pay_code" ref="pay_code" style="width: 260px; height: 260px"></canvas>
        <div style="display: flex; justify-content: center">
          <el-button @click="value = false">取消支付</el-button>
          <el-button @click="value = false; $emit('success', '')" type="primary">已支付</el-button>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import {MessageBox} from "element-ui";
import {PayService} from "@/common/service";
import * as QRCode from "qrcode";

export default {
  components: {},
  name: 'ali-wechat-pay',
  data() {
    return {
      value: false,
    };
  },
  mounted() {},
  methods: {
    /**
     *
     * @param {{pay_type: string, out_trade_no: string }} params
     */
    pay(params) {
      PayService.pay(params).then(({data}) => {
        console.log(data)
        if (data.type === 'url') {
          // location.href = data.data;
          MessageBox({
            type: 'warning',
            title: '提示',
            message: '是否已完成？',
            showCancelButton: true,
            confirmButtonText: '已完成',
            cancelButtonText: '取消支付',
          }).then(() => {
            this.$emit('success', '');
          }).catch(() => {
            this.value = false;
          });
          setTimeout(() => {
            window.open(data.data, "_blank");
          }, 100);
        } else if (data.type === 'qrcode') {
          this.value = true;
          setTimeout(() => {
            const canvas = this.$refs['pay_code'];
            QRCode.toCanvas(canvas, data.qrcode, {width: 260,margin: 1})
          }, 50);
        }
      })
    },
    payClose(done) {
      MessageBox({
        type: 'warning',
        title: '提示',
        message: '是否已完成？',
        showCancelButton: true,
        confirmButtonText: '已完成',
        cancelButtonText: '取消支付',
      }).then(() => {
        this.$emit('success', '');
        done();
      }).catch(() => {
        this.value = false;
      });
    },
  },
}
</script>

<style scoped></style>
